(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["club54-holiday-popup"] && !Shopify.designMode) return;
  try {
    
  const initClub54HolidayPopup = (modal) => {
    if (!(modal instanceof HTMLElement) || modal.hasAttribute('data-initialized')) {
      return;
    }

    modal.setAttribute('data-initialized', '');

    Object.defineProperty(modal, 'clickOutsideDeactivates', {
      configurable: true,
      get() {
        return false;
      },
    });

    modal.hideForOutsideClickTarget = () => false;

    const overlay = typeof modal.getShadowPartByName === 'function' ? modal.getShadowPartByName('overlay') : null;
    if (overlay) {
      overlay.addEventListener(
        'click',
        (event) => {
          event.stopImmediatePropagation();
        },
        true,
      );
    }

    const animatePopup = (isEnter) => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const overlayPart = typeof modal.getShadowPartByName === 'function' ? modal.getShadowPartByName('overlay') : null;
      const contentPart = typeof modal.getShadowPartByName === 'function' ? modal.getShadowPartByName('content') : null;
      const duration = reduceMotion ? 1 : isEnter ? 320 : 240;
      const easing = isEnter ? 'cubic-bezier(0.22, 1, 0.36, 1)' : 'cubic-bezier(0.4, 0, 0.68, 1)';
      const overlayFrames = isEnter ? [{ opacity: 0 }, { opacity: 1 }] : [{ opacity: 1 }, { opacity: 0 }];
      const contentFrames = isEnter
        ? [
            { opacity: 0, transform: 'translateY(16px) scale(0.96)' },
            { opacity: 1, transform: 'translateY(0) scale(1)' },
          ]
        : [
            { opacity: 1, transform: 'translateY(0) scale(1)' },
            { opacity: 0, transform: 'translateY(12px) scale(0.96)' },
          ];
      const options = { duration, easing, fill: 'forwards' };
      const animations = [];

      if (overlayPart) {
        animations.push(overlayPart.animate(overlayFrames, options));
      }

      if (contentPart) {
        animations.push(contentPart.animate(contentFrames, options));
      }

      if (animations.length === 0) {
        return modal.animate(overlayFrames, options);
      }

      return {
        finished: Promise.all(animations.map((animation) => animation.finished)),
        finish() {
          animations.forEach((animation) => animation.finish());
        },
      };
    };

    modal.createEnterAnimationControls = () => animatePopup(true);
    modal.createLeaveAnimationControls = () => animatePopup(false);

    const delay = Number.parseInt(modal.getAttribute('data-apparition-delay') || '0', 10) * 1000;

    const showPopup = () => {
      if (typeof modal.show === 'function') {
        modal.show();
      }
    };

    const schedule = () => {
      if (modal.getAttribute('data-club54-holiday-popup') === 'expired' && window.location.hash === '#club-login') {
        return;
      }

      window.setTimeout(showPopup, Number.isFinite(delay) ? delay : 0);
    };

    if (window.customElements.get('x-modal')) {
      schedule();
      return;
    }

    customElements.whenDefined('x-modal').then(schedule);
  };

  const initVisiblePopups = (root = document) => {
    root.querySelectorAll('[data-club54-holiday-popup]').forEach(initClub54HolidayPopup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initVisiblePopups());
  } else {
    initVisiblePopups();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initVisiblePopups(event.target);
  });
  document.addEventListener('click', (event) => {
    const loginLink = event.target.closest('.club54-holiday-popup__login');
    if (loginLink) {
      try {
        sessionStorage.setItem('theme:club54-holiday-login-return', window.location.pathname);
      } catch (error) {}
      return;
    }

    const closeButton = event.target.closest('.club54-holiday-popup__close');
    if (closeButton) {
      event.preventDefault();
      closeButton.closest('x-modal')?.hide();
      return;
    }

    const clubLoginButton = event.target.closest('.club54-holiday-popup__club-login');
    if (!clubLoginButton) {
      return;
    }

    event.preventDefault();

    const modal = clubLoginButton.closest('x-modal');
    const openClubLoginDrawer = () => {
      const hash = '#club-login';
      if (window.location.hash === hash) {
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }
      window.location.hash = hash;
    };

    if (modal && typeof modal.hide === 'function') {
      modal.addEventListener('dialog:after-hide', openClubLoginDrawer, { once: true });
      modal.hide();
      return;
    }

    openClubLoginDrawer();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-popup"] && !Shopify.designMode) return;
  try {
    
  const initCollectionPopup = (modal) => {
    if (!(modal instanceof HTMLElement) || modal.hasAttribute('data-initialized')) {
      return;
    }

    modal.setAttribute('data-initialized', '');

    const storageKey = modal.getAttribute('data-storage-key') || '';
    const showOnlyOnce = modal.hasAttribute('data-only-once');
    const isDesignMode = modal.hasAttribute('data-design-mode');
    const delay = Number.parseInt(modal.getAttribute('data-apparition-delay') || '0', 10) * 1000;

    const forceShow = () => {
      try {
        return new URLSearchParams(window.location.search).has('show_collection_popup');
      } catch (error) {
        return false;
      }
    };

    const hasSeen = () => {
      if (isDesignMode || !showOnlyOnce || !storageKey || forceShow()) {
        return false;
      }

      try {
        return sessionStorage.getItem(storageKey) === 'true';
      } catch (error) {
        return false;
      }
    };

    const markSeen = () => {
      if (isDesignMode || !showOnlyOnce || !storageKey || forceShow()) {
        return;
      }

      try {
        sessionStorage.setItem(storageKey, 'true');
      } catch (error) {}
    };

    const animatePopup = (isEnter) => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const overlayPart = typeof modal.getShadowPartByName === 'function'
        ? modal.getShadowPartByName('overlay')
        : null;
      const contentPart = typeof modal.getShadowPartByName === 'function'
        ? modal.getShadowPartByName('content')
        : null;
      const duration = reduceMotion
        ? 1
        : isEnter
          ? 320
          : 240;
      const easing = isEnter
        ? 'cubic-bezier(0.22, 1, 0.36, 1)'
        : 'cubic-bezier(0.4, 0, 0.68, 1)';
      const overlayFrames = isEnter
        ? [
          {
            opacity: 0
          }, {
            opacity: 1
          }
        ]
        : [
          {
            opacity: 1
          }, {
            opacity: 0
          }
        ];
      const contentFrames = isEnter
        ? [
          {
            opacity: 0,
            transform: 'translateY(16px) scale(0.96)'
          }, {
            opacity: 1,
            transform: 'translateY(0) scale(1)'
          }
        ]
        : [
          {
            opacity: 1,
            transform: 'translateY(0) scale(1)'
          }, {
            opacity: 0,
            transform: 'translateY(12px) scale(0.96)'
          }
        ];
      const options = {
        duration,
        easing,
        fill: 'forwards'
      };
      const animations = [];

      if (overlayPart) {
        animations.push(overlayPart.animate(overlayFrames, options));
      }

      if (contentPart) {
        animations.push(contentPart.animate(contentFrames, options));
      }

      if (animations.length === 0) {
        return modal.animate(overlayFrames, options);
      }

      return {
        finished: Promise.all(animations.map((animation) => animation.finished)),
        finish() {
          animations.forEach((animation) => animation.finish());
        }
      };
    };

    modal.createEnterAnimationControls = () => animatePopup(true);
    modal.createLeaveAnimationControls = () => animatePopup(false);

    const showPopup = () => {
      if (hasSeen()) return;
      


      if (typeof modal.show === 'function') {
        modal.show();
      }
      markSeen();
    };

    const schedule = () => {
      window.setTimeout(
        showPopup,
        Number.isFinite(delay)
          ? delay
          : 0
      );
    };

    if (window.customElements.get('x-modal')) {
      schedule();
      return;
    }

    customElements.whenDefined('x-modal').then(schedule);
  };

  const initCollectionPopups = (root = document) => {
    root.querySelectorAll('[data-collection-popup]').forEach(initCollectionPopup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCollectionPopups());
  } else {
    initCollectionPopups();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCollectionPopups(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initNewsletterForm = (form) => {
      if (!(form instanceof HTMLFormElement) || form.hasAttribute('data-newsletter-initialized')) {
        return;
      }

      form.setAttribute('data-newsletter-initialized', '');
      form.setAttribute('novalidate', '');

      const emailInput = form.querySelector('input[type="email"]');
      const errorEl = form.querySelector('[data-newsletter-error]');

      if (!emailInput || !errorEl) {
        return;
      }

      const showError = () => {
        errorEl.hidden = false;
        emailInput.setAttribute('aria-invalid', 'true');
      };

      const hideError = () => {
        errorEl.hidden = true;
        emailInput.removeAttribute('aria-invalid');
      };

      form.addEventListener('submit', (event) => {
        if (emailInput.value.trim() === '' || !emailInput.checkValidity()) {
          event.preventDefault();
          showError();
          emailInput.focus();
        }
      });

      emailInput.addEventListener('input', () => {
        if (emailInput.value.trim() !== '' && emailInput.checkValidity()) {
          hideError();
        }
      });
    };

    const initNewsletterForms = (root = document) => {
      root.querySelectorAll?.('.newsletter-form').forEach(initNewsletterForm);
    };

    initNewsletterForms();

    document.addEventListener('shopify:section:load', (event) => {
      initNewsletterForms(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
